import { useEffect, useMemo } from "react";
import { useBoundStore } from "components/canvas/stores/useAppStore";

/** `TablePermissions` (common_core `relation/permissions.rs`) as the cache holds it. */
export interface TablePermissions {
  can_see_shared_with_list: boolean;
  can_share: boolean;
  can_revoke_access: boolean;
  can_import: boolean;
  can_checkpoint: boolean;
  can_transfer: boolean;
  can_edit: boolean;
  is_catalog_member: boolean;
  can_read_values: boolean;
}

/** A table's permissions, `null` until they land. It always asks: the core
 *  drops a request already in flight and refreshes only past its TTL. */
export function useTablePermissions(
  tableId: string | null | undefined,
): TablePermissions | null {
  const clientApp = useBoundStore((s) => s.clientApp);
  const version = useBoundStore((s) => s.permissionsVersion);
  useEffect(() => {
    if (clientApp && tableId) clientApp.fetch_table_permissions(tableId);
  }, [clientApp, tableId]);
  return useMemo(
    () =>
      clientApp && tableId
        ? ((clientApp.peek_table_permissions(tableId) as TablePermissions) ??
          null)
        : null,
    // The version is a re-read trigger, not an input.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clientApp, tableId, version],
  );
}
